<template>
    <div class="dropdown-container">
        <span class="btn-group btn-group-sm" ref="buttonGroup" role="group" aria-label="Comandos de Edição">
            <button :type="buttonType" :class="buttonClass" @click="$emit('click')">
                <svg-icon :icon="buttonIcon"/><span> {{buttonLabel}}</span>
            </button>
            <button v-if="showCaret"
                    type="button"
                    :class="[buttonCaretClass]"
                    v-closable="{
                        exclude: ['menu'],
                        handler: 'closeMenu'
                    }"
                    @click="showMenu">
                <svg-icon :icon="svgIcon()"/>
            </button>
        </span>
        <ul :class="[menuPosition, {show: isShow}]"
            ref="menu"
            :style="styleMenu">
            <slot name="items"/>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "Dropdown",
        props: {
            menuPosition: {
                type: String,
                default: 'down',
                validator: val => /(up|down)/gi.test(val)
            },
            showCaret: {
                type: Boolean,
                default:false
            },
            buttonLabel: {
                type: String,
                default: 'Botão'
            },
            buttonType: {
                type: String,
                default: 'button'
            },
            buttonClass: {
                type: String,
                default: 'btn'
            },
            buttonIcon: {
                type: String,
                default: 'save'
            },
            buttonCaretClass: {
                type: String,
                default: 'btn'
            }
        },
        data() {
            return {
                isShow:false,
                styleMenu: {}
            }
        },
        methods: {
            showMenu() {
                this.isShow = !this.isShow;

                if (this.menuPosition === 'up') {
                    const bounds = this.$refs.buttonGroup.getBoundingClientRect();
                    const boundsMenu = this.$refs.menu.getBoundingClientRect();
                    const height = bounds.height + boundsMenu.height + 2;

                    this.$set(this.styleMenu, 'transform', `translate3d(-${200 - bounds.width}px, calc(-100% - ${height}px), 0px)`);
                }
            },
            closeMenu() {
                this.isShow = false;
            },
            svgIcon() {
                if (this.isShow) return 'times';

                return this.menuPosition === 'up' ? 'sort-up' : 'sort-down';
            }
        }
    }
</script>

<style lang="scss">
    @import "../../assets/css/variables";
    @import "../../assets/css/animations";
    .dropdown-container {
        position: relative;
        ul {
            display: none;
            flex-direction: column;
            align-items: flex-start;
            justify-items: center;
            position: absolute;
            list-style: none;
            min-width: 200px;
            border-radius: 5px;
            border: 1px solid rgba(0,0,0, .1);
            margin: 0;
            padding: 0;
            overflow: hidden;
            background-color: #fff;
            width: 100%;
            box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);

            &.down {
                margin-top: 2px;
            }

            li {
                display: flex;
                justify-items: center;
                font-size: .9em;
                width: 100%;

                &.divider {
                    border-top: 1px solid rgba(0,0,0, .1);
                }

                a {
                    width: 100%;
                    height: 100%;
                    padding: 5px;
                    text-decoration: none;
                    display: inline-block;
                    color: inherit;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    transition: color .2s ease;
                    text-align: left;

                    &:hover {
                        color: $theme_color_one;
                    }

                    svg {
                        width: .9em;
                        height: .9em;
                        margin-right: 5px;
                    }
                }
            }

            &.show {
                display: flex;
                z-index: 2;
            }
        }
    }
</style>
